import type { SvgType } from './types'

export default function Skip({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        d="M12 7V10.3523L8.21719 7.53977L7.5 7.0142V16.9858L8.21719 16.4602L12 13.6477V17L12.7172 16.4602L18.1173 12.3693L18.5954 12L18.1173 11.6307L12.7172 7.53977L12 7ZM8.40001 8.80398L12.1828 11.6165L12.6891 12L12.1828 12.3835L8.40001 15.196V8.80398ZM12.9 8.81818L17.0907 12L12.9 15.1818V8.81818Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="9" stroke={fill} strokeWidth="2" />
    </svg>
  )
}
